import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useState,} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {useRouterSearchParam} from "../../../modules/navigation/useOnLocationChange";
import WorkspaceContext from "../WorkspaceContext";
import _ from "lodash"
import WorkspaceOrganizationDepartmentDetail from "./WorkspaceOrganizationDepartmentDetail";
import WorkspaceOrganizationDepartmentList from "./WorkspaceOrganizationDepartmentList";

export const WorkspaceOrgDeptContainerContext = React.createContext(
    {}
)

const WorkspaceOrgDeptContainerProvider = ({children}) => {
    const currentDepartmentId = useRouteSearchParam("current_department_id")
    const [current_department_id, setCurrentDepartmentId] = useState(currentDepartmentId)

    const {onChangeSearchParams} = useRouterSearchParam({})

    const onSelectWorkspaceOrgDeptContainerRoute = (values) => {
        if (_.has(values, 'current_department_id')) setCurrentDepartmentId(values?.current_department_id)

        onChangeSearchParams(values)
    }

    return (
        <WorkspaceOrgDeptContainerContext.Provider
            value={{
                current_department_id, setCurrentDepartmentId,
                ...{onSelectWorkspaceOrgDeptContainerRoute}
            }}>
            {children}
        </WorkspaceOrgDeptContainerContext.Provider>
    )
}


const WorkspaceOrgDeptContainer = ({}) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);
    const currentDepartmentId = useRouteSearchParam("current_department_id")
    const {
        current_department_id, setCurrentDepartmentId,
    } = useContext(WorkspaceOrgDeptContainerContext)

    useEffect(() => {
        setCurrentDepartmentId(currentDepartmentId)
    }, [currentDepartmentId])

    if (!!current_department_id) {
        return (
            <WorkspaceOrganizationDepartmentDetail/>
        )
    }

    return (
        <WorkspaceOrganizationDepartmentList/>
    )
}


export default nest(WorkspaceOrgDeptContainerProvider, WorkspaceOrgDeptContainer)
